// extracted by mini-css-extract-plugin
export default {"spinner":"ButtonSpinner_spinner__P+pHT","spin":"ButtonSpinner_spin__CWARm"};